import RestResource from '../rest.service';

export default class DocumentReceiptTypesService extends RestResource {
  constructor() {
    super('document-receipt-types');
  }
}
